import fetch from "../fetch";
import pickBy from "lodash/pickBy";

export default ({ params }) => {
  return fetch({ path: "/abs/deals", params: pickBy(params) });
};
